const categorys = ['뉴스','컬처','미래와 역사','에세네 라이프'];

export default categorys;